import { Pipe, PipeTransform } from '@angular/core';

/** Tooltip for the day-count cells; empty when nothing is planned. */
@Pipe({
    name: 'plannedDaysTitle',
    standalone: false,
})
export class PlannedDaysTitlePipe implements PipeTransform {
    transform(count: number | null | undefined): string {
        return count ? `Ingepland op ${count} ${count === 1 ? 'dag' : 'dagen'}` : '';
    }
}
